import { DataTable } from '@app/components/data-table/data-table';
import { useDataTable } from '@app/components/data-table/hooks/use-data-table';
import { OperationActivityModelledFoodBaseFood, Unit } from '@shared/api/types';
import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import { NumberCell } from '@shared/components/data-table/cells/number-cell';
import RatingCloud, {
  RatingCloudProps,
} from '@shared/components/ratings/rating-cloud';
import { ColumnDef } from '@tanstack/react-table';

const columns: ColumnDef<OperationActivityModelledFoodBaseFood>[] = [
  {
    accessorKey: 'uuid',
  },
  {
    accessorKey: 'name',
    accessorFn: (row) => row.baseFood.name,
    header: ({ column }) => (
      <HeaderCell column={column} name="Ingredient" className="pl-0" />
    ),
    cell: ({ getValue }) => <p>{getValue<string>()}</p>,
    enableSorting: false,
  },
  {
    accessorKey: 'quantity',
    header: ({ column }) => (
      <HeaderCell
        column={column}
        name="Quantity"
        className="text-right"
        numberColumn
      />
    ),
    cell: ({ getValue }) => {
      const quantity = getValue<number>();
      return quantity ? <NumberCell number={getValue<number>()} /> : null;
    },
    enableSorting: false,
  },
  {
    id: 'unit',
    accessorKey: 'unit',
    header: ({ column }) => <HeaderCell column={column} name="Unit" />,
    cell: ({ getValue }) => <p>{getValue<Unit>().shortDesc}</p>,
    enableSorting: false,
  },
  {
    accessorKey: 'emissionsCategory',
    header: ({ column }) => (
      <HeaderCell column={column} name="Rating" className="text-right" />
    ),
    cell: ({ getValue }) => {
      const rating = getValue<RatingCloudProps['rating']>();
      return (
        (rating && (
          <RatingCloud
            rating={rating as RatingCloudProps['rating']}
            className="ml-auto w-12"
          />
        )) ??
        null
      );
    },
    enableSorting: false,
  },
];

interface MiniIngredientTableProps {
  data: OperationActivityModelledFoodBaseFood[];
}

export default function MiniIngredientTable({
  data,
}: MiniIngredientTableProps) {
  const { table } = useDataTable({
    data: data,
    columns,
    initialState: {
      columnVisibility: {
        uuid: false,
      },
      pagination: {
        pageSize: 100,
        pageIndex: -1,
      },
    },
  });

  return (
    <>
      <DataTable
        table={table}
        className="bg-gray-25"
        cellClassName="py-2 pl-0"
        headerConfig={{
          cell: 'pl-0',
        }}
        pagination={false}
      />
    </>
  );
}
